import React from 'react';
import ReactDOM from 'react-dom';
import reducers from './reducers';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './navbar.css'
import App from "./components/App";

const createStoreWithMiddleware = applyMiddleware(
    promiseMiddleware()
)(createStore);

export const store = createStoreWithMiddleware(reducers);

ReactDOM.render(<Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js